import React from 'react'
import { Toaster } from '@CommonComponents/toast'
import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { StateProvider } from '@State'
import LoadingInfo from './LoadingInfo'

export const CourseLoadingApp = ({
  templateCoursenum,
  newCoursenum,
  instrId,
  targetUrl,
}) => {
  let history = createBrowserHistory({ forceRefresh: true })
  const initialState = {
    templateCoursenum: templateCoursenum,
    newCoursenum: newCoursenum,
    instrId: instrId,
    targetUrl: targetUrl,
    isSetUp: false,
    isSettingUp: false,
    loadingDone: false,
  }

  return (
    <Router history={history}>
      <StateProvider initialState={initialState} reducer={reducer}>
        <Toaster />
        <h2>Configuring your material...</h2>
        <p className="mt-5">This may take a few moments</p>
        <LoadingInfo />
      </StateProvider>
    </Router>
  )
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'updateLoadingDone':
      return {
        ...state,
        loadingDone: action.payload,
      }
    case 'updateSetupStatus':
      return {
        ...state,
        isSetUp: action.payload.isSetUp,
        isSettingUp: action.payload.isSettingUp,
      }
  }
}
